import { Check, Ban, ArrowLeftRight } from 'lucide-react';

type StatusType = 'fixed' | 'subs' | 'on subs' | 'failed';

interface FixtureStatusProps {
  status: string;
  className?: string;
}

const statusConfig: Record<
  StatusType,
  {
    color: string;
    label: string;
    icon: React.ReactNode;
  }
> = {
  fixed: {
    color: '#00B38B',
    label: 'Fixed',
    icon: <Check className="h-4 w-4" />,
  },
  subs: {
    color: '#F5A31A',
    label: 'On Subs',
    icon: <ArrowLeftRight className="h-4 w-4" />,
  },
  'on subs': {
    color: '#F5A31A',
    label: 'On Subs',
    icon: <ArrowLeftRight className="h-4 w-4" />,
  },
  failed: {
    color: '#E71414',
    label: 'Failed',
    icon: <Ban className="h-4 w-4" />,
  },
};

export function FixtureStatus({ status, className = '' }: FixtureStatusProps) {
  const normalizedStatus = status.toLowerCase() as StatusType;
  const config = statusConfig[normalizedStatus];

  if (!config) {
    return <span className={className}>{status}</span>;
  }

  return (
    <div
      className={`inline-flex items-center gap-1.5 font-semibold leading-none ${className}`}
      style={{ color: config.color }}
    >
      {config.icon}
      <span className="leading-none">{config.label}</span>
    </div>
  );
}
